import { CityState, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomerQuickInfoMulticompany extends Layout {
    citystate1: CityState;
    labelBridgeIdDescription: Textbox;
    labelCustomerWebsite: Textbox;
    panel1: Panel;
    sourceCustomerLookupMulticompany: DataSource;
    textboxBridgeCustomer: Textbox;
    textboxEdiCustomerCarrier: Textbox;
    textboxId: Textbox;
    textboxName: Textbox;
    textboxPartnerValue: Textbox;
    textboxSalespersonName: Textbox;
    textboxScac: Textbox;
}
